import { render, staticRenderFns } from "./ListPurchasePoint.vue?vue&type=template&id=ccd9d02a&"
import script from "./ListPurchasePoint.vue?vue&type=script&lang=js&"
export * from "./ListPurchasePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports